// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@nrwl/web/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flag_flag__3Ogyz {\n  width: 30px;\n  height: 20px;\n}", ""]);
// Exports
exports.locals = {
	"flag": "flag_flag__3Ogyz"
};
module.exports = exports;
